import moment from 'moment';

import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';

export default {
  getCustomerDetails(contact) {
    let customer = null;

    return Firebase.firestore()
      .collection('users')
      .where('mobile', '==', contact)
      .get()
      .then(docs => {
        return Firestore.getAllReferenceData(docs, ['city']);
      })
      .then(data => {
        customer = data[0];
        if (!customer) {
          return null;
        }

        return customer;
      });
  },

  getOrders(customer, date) {
    const userRef = Firebase.firestore()
      .collection('users')
      .doc(customer);
    const start = moment(date)
      .toDate()
      .valueOf();
    const end = moment(date)
      .endOf('day')
      .toDate()
      .valueOf();

    return Firebase.firestore()
      .collection('orders')
      .where('user', '==', userRef)
      .where('datetime', '>=', start)
      .where('datetime', '<', end)
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  updateWalletBalance(customer, transaction) {
    const { amount, reason, reference } = transaction;
    const { docId, walletBalance } = customer;

    const userObj = {
      walletBalance: walletBalance + amount
    };

    const transactionObj = {
      amount,
      reason,
      reference
    };

    return Firebase.firestore()
      .collection('users')
      .doc(docId)
      .update(userObj)
      .then(() => {
        return Firebase.firestore()
          .collection('users')
          .doc(docId)
          .collection('wallet-transactions')
          .add(transactionObj);
      });
  }
};



// WEBPACK FOOTER //
// ./src/pages/records/service.js